module.exports = __webpack_public_path__ + "static/media/increase-revenue-icon.7f0f4ca9.svg";